export default __webpack_public_path__ + "static/media/pay_success.0d333a47.png";